/** @file One animation's dopesheet: groups by target, the row layout and the animation length. */
import { timelineLayout } from '@pose2d/editor-geometry/timelineLayout';
import type { TimelineGroupInput, TimelineLayout } from '@pose2d/editor-geometry/types';
import type { Doc, Id } from '@pose2d/format/types';
import { animationFrames } from '../../../playback/animationFrames';
import { DOPE_PX } from '../draw/dopeMetrics';
import { dopesheetGroups } from './dopesheetGroups';

/** What the canvas draws and the pointer hit-tests; rebuilt when the document, animation, selection or folds change. */
export interface DopeModel {
  animation: Id;
  groups: ReadonlyMap<string, TimelineGroupInput>;
  layout: TimelineLayout;
  /** Animation length in frames. */
  end: number;
}

/** null for a missing animation; `show` = selected bones and slots, `collapsed` = folded group targets. */
export function dopesheetModel(doc: Doc, animation: Id, show: ReadonlySet<Id>, collapsed: ReadonlySet<string>): DopeModel | null {
  const anim = doc.animations[animation];
  if (anim === undefined) return null;
  const list = dopesheetGroups(doc, animation, show);
  return { animation, groups: new Map(list.map((g) => [g.target, g])), layout: timelineLayout(list, collapsed, DOPE_PX.row), end: animationFrames(anim) };
}
